import { useMutation } from "react-query";
import { deleteFireAlarmSystem } from "actions/CarrierAgreementMgmt/Security";
import { toast } from "components/toastNotification";

const useDeleteFireAlarmSystem = () => {
    const { mutate, reset, isSuccess, data, error, isError } = useMutation(deleteFireAlarmSystem, {
        onError: () => {
            toast.fire(
                "Unexpected issue",
                "Unable to deactivate the Fire Alarm System right now. Please try again shortly.",
                "error"
            );
        }
    });

    return {
        mutate,
        isSuccess,
        data: error ? { status: 500 } : data ?? { status: 500 },
        reset,
        isError
    }
};
export default useDeleteFireAlarmSystem;
